import { useEffect, useState } from "react";
import "../assets/css/staff.css";
import { GenCardsH, GenCardsV } from "./staff_genCards";
import adminBoard from "../api/staff/adminBoard.json";
import axios from "axios";

import AOS from "aos";
import "aos/dist/aos.css";

// import adminboardData from "../api/staff/adminBoard.json";
// import officeboardData from "../api/staff/officeBoard.json";
// import lecturersData from "../api/staff/lecturers.json";
// import officersData from "../api/staff/officers.json";
// import course_arData from "../api/staff/course_ar.json";
// import course_laData from "../api/staff/course_la.json";
// import course_ltData from "../api/staff/course_lt.json";
// import course_avData from "../api/staff/course_av.json";
// import course_muData from "../api/staff/course_mu.json";
// import course_drData from "../api/staff/course_dr.json";

// const apiUrl = process.env.REACT_APP_API_URL;
const jsonUrl = process.env.REACT_APP_API_URL;

const showConsole = false;

// const srcApi = "https://aed.mju.ac.th/api/arch/";

export default function StaffInformation(props) {
    const boardName = props.boardName;
    // console.log("boardName:", boardName);

    const [isLoading, setIsLoading] = useState(true);
    // const [usersBoard, setUsersBoard] = useState([]);
    const [strTitle, setStrTitle] = useState("ทำเนียบ");

    const [adminboard, setAdminboard] = useState([]);
    const [officeboard, setOfficeboard] = useState([]);
    const [lecturers, setLecturers] = useState([]);
    const [officers, setOfficers] = useState([]);
    // const [officers2, setOfficers2] = useState([]);
    const [course_ar, setCourse_ar] = useState([]);
    const [course_la, setCourse_la] = useState([]);
    const [course_lt, setCourse_lt] = useState([]);
    const [course_av, setCourse_av] = useState([]);
    const [course_mu, setCourse_mu] = useState([]);
    const [course_dr, setCourse_dr] = useState([]);

    const boardTitles = {
        adminboard: "ผู้บริหารคณะสถาปัตยกรรมศาสตร์และการออกแบบสิ่งแวดล้อม",
        officeboard: "โครงสร้างสำนักงานคณบดี",
        lecturers: "บุคลากรสายวิชาการ",
        officers: "บุคลากรสายสนับสนุน",
        course_ar: "อาจารย์ผู้รับผิดชอบหลักสูตรสถาปัตยกรรมศาสตร",
        course_la: "อาจารย์ผู้รับผิดชอบหลักสูตรภูมิสถาปัตยกรรมศาสตร",
        course_lt: "อาจารย์ผู้รับผิดชอบหลักสูตรเทคโนโลยีภูมิทัศน์",
        course_av: "อาจารย์ผู้รับผิดชอบหลักสูตรการออกแบบและวางแผนสิ่งแวดล้อม",
        course_mu: "อาจารย์ผู้รับผิดชอบหลักสูตรการวางผังเมืองและสภาพแวดล้อม",
        course_dr: "อาจารย์ผู้รับผิดชอบหลักสูตรนวัตกรรมการออกแบบเพื่อความยั่งยืน",
    };

    async function getJsonData() {
        // return Axios.get("https://faed.mju.ac.th/api/arch/staff/lecturers.json");
        let path = '';
        
        path = `staff/adminBoard.json`;
        await axios
            .get(`${jsonUrl}${path}`)
            .then((res) => {
                setAdminboard(res.data);
                showConsole && console.log(`get adminBoard axios url: ${jsonUrl}${path}`);
            })
            .catch((error) => {
                showConsole && console.error(`get adminBoard axios err: ${error}`);
            });

        path = `staff/officeBoard.json`;
        await axios
            .get(`${jsonUrl}${path}`)
            .then((res) => {
                setOfficeboard(res.data);
                showConsole && console.log(`get officeBoard axios url: ${jsonUrl}${path}`);
            })
            .catch((error) => {
                showConsole && console.error(`get officeBoard axios err: ${error}`);
            });

        path = `staff/lecturers.json`;
        await axios
            .get(`${jsonUrl}${path}`)
            .then((res) => {
                setLecturers(res.data);
                showConsole && console.log(`get lecturers axios url: ${jsonUrl}${path}`);
            })
            .catch((error) => {
                showConsole && console.error(`get lecturers axios err: ${error}`);
            });

        path = `staff/officers.json`;
        await axios
            .get(`${jsonUrl}${path}`)
            .then((res) => {
                setOfficers(res.data);
                showConsole && console.log(`get officers axios url: ${jsonUrl}${path}`);
            })
            .catch((error) => {
                showConsole && console.error(`get officers axios err: ${error}`);
            });

        path = `staff/course_ar.json`;
        await axios
            .get(`${jsonUrl}${path}`)
            .then((res) => {
                setCourse_ar(res.data);
                showConsole && console.log(`get course_ar axios url: ${jsonUrl}${path}`);
            })
            .catch((error) => {
                showConsole && console.error(`get course_ar axios err: ${error}`);
            });

        path = `staff/course_la.json`;
        await axios
            .get(`${jsonUrl}${path}`)
            .then((res) => {
                setCourse_la(res.data);
                showConsole && console.log(`get course_la axios url: ${jsonUrl}${path}`);
            })
            .catch((error) => {
                showConsole && console.error(`get course_la axios err: ${error}`);
            });

        path = `staff/course_lt.json`;
        await axios
            .get(`${jsonUrl}${path}`)
            .then((res) => {
                setCourse_lt(res.data);
                showConsole && console.log(`get course_lt axios url: ${jsonUrl}${path}`);
            })
            .catch((error) => {
                showConsole && console.error(`get course_lt axios err: ${error}`);
            });

        path = `staff/course_av.json`;
        await axios
            .get(`${jsonUrl}${path}`)
            .then((res) => {
                setCourse_av(res.data);
                showConsole && console.log(`get course_av axios url: ${jsonUrl}${path}`);
            })
            .catch((error) => {
                showConsole && console.error(`get course_av axios err: ${error}`);
            });

        path = `staff/course_mu.json`;
        await axios
            .get(`${jsonUrl}${path}`)
            .then((res) => {
                setCourse_mu(res.data);
                showConsole && console.log(`get course_mu axios url: ${jsonUrl}${path}`);
            })
            .catch((error) => {
                showConsole && console.error(`get course_mu axios err: ${error}`);
            });

        path = `staff/course_dr.json`;
        await axios
            .get(`${jsonUrl}${path}`)
            .then((res) => {
                setCourse_dr(res.data);
                showConsole && console.log(`get course_dr axios url: ${jsonUrl}${path}`);
            })
            .catch((error) => {
                showConsole && console.error(`get course_dr axios err: ${error}`);
            });
    }

    useEffect(() => {

        getJsonData();
        AOS.init();

    }, []);

    function genBoardTitle() {
        return (
            <div className="staffHolder text-center">
                <h1 style={{ marginBottom: "50px" }}>{strTitle}</h1>
            </div>
        );
    }

    function genUserBoard(users, courseboard = false) {
        showConsole && console.log("user2: ", users);
        return <GenCardsH items={users} sm={1} md={1} lg={1} courseboard={courseboard} />;
    }


    function genLecturers(users) {
        showConsole && console.log("lecturers:",users);
        if (Array.isArray(users)) {
            //   console.log("itemOK:", usersBoard.length);
            return users.map((item, key) => {
                return (
                    <GenCardsV
                        key={key}
                        strSubTitle={item["category"]}
                        strSubTitleEn={item["categoryEn"]}
                        items={item["users"]}
                        sm={2}
                        md={2}
                        lg={3}
                    />
                );
                // return usersBoard[index]["users"].map((item) => {
                //   return genUserCard(item);
                // });
            });
        } else {
            showConsole && console.error("fail to read json");
        }

    }

    function genOfficers(users) {
        // showConsole && console.log("lecturers:",users);
        if (users.length > 0) {
              console.log("itemOK:", users.length);
            return users.map((item, key) => {
                return (
                    <GenCardsV
                        key={key}
                        strSubTitle={item.category}
                        items={item.users}
                        sm={2}
                        md={2}
                        lg={3}
                    />
                );
            //     // return usersBoard[index]["users"].map((item) => {
            //     //   return genUserCard(item);
            //     // });
            });
        } else {
            showConsole && console.error("fail to read json");
        }

    }

    useEffect(() => {
        // let result = "";
        // let userjsonUrl = "";
        let result = "";
        const fetchData = async () => {
            try {
                if (boardName !== "") {
                    // result = usersData[boardName];
                    // userjsonUrl = jsonUrl[boardName];
                    setStrTitle(boardTitles[boardName]);
                }
                if (
                    typeof result == "object" &&
                    JSON.stringify(result).length > 5
                ) {
                    // setUsersBoard(result);
                } else {
                    showConsole && console.error("data condition ล้มเหลว");
                }
                setIsLoading(false);
            } catch (e) {
                showConsole && console.error("axios Error: ", e);
            }
        };
        fetchData();

        // AOS.init();
        // eslint-disable-next-line
    }, []);

    if (boardName) {
        if (isLoading) {
            return <div className="h3">ขออภัยไม่พบข้อมูล....</div>;
        } else {
            if (boardName === "officers") {
                return (
                    <div key={boardName} style={{ marginTop: "50px" }}>
                        {genBoardTitle()}
                        {genOfficers(officers)}
                    </div>
                );
            } else if (boardName === "lecturers") {
                return (
                    <div key={boardName} style={{ marginTop: "50px" }}>
                        {genBoardTitle()}
                        {genLecturers(lecturers)}
                    </div>
                );
            } else if (boardName === "adminboard") {
                return (
                    <div key={boardName} style={{ marginTop: "50px" }}>
                        {genBoardTitle()}
                        {genUserBoard(adminboard, true)}
                    </div>
                );
            } else if (boardName === "officeboard") {
                return (
                    <div key={boardName} style={{ marginTop: "50px" }}>
                        {genBoardTitle()}
                        {genUserBoard(officeboard)}
                    </div>
                );
            } else if (boardName === "course_ar") {
                return (
                    <div key={boardName} style={{ marginTop: "50px" }}>
                        {genBoardTitle()}
                        {genUserBoard(course_ar, true)}
                    </div>
                );
            } else if (boardName === "course_la") {
                return (
                    <div key={boardName} style={{ marginTop: "50px" }}>
                        {genBoardTitle()}
                        {genUserBoard(course_la, true)}
                    </div>
                );
            } else if (boardName === "course_lt") {
                return (
                    <div key={boardName} style={{ marginTop: "50px" }}>
                        {genBoardTitle()}
                        {genUserBoard(course_lt, true)}
                    </div>
                );
            } else if (boardName === "course_mu") {
                return (
                    <div key={boardName} style={{ marginTop: "50px" }}>
                        {genBoardTitle()}
                        {genUserBoard(course_mu, true)}
                    </div>
                );
            } else if (boardName === "course_av") {
                return (
                    <div key={boardName} style={{ marginTop: "50px" }}>
                        {genBoardTitle()}
                        {genUserBoard(course_av, true)}
                    </div>
                );
            } else if (boardName === "course_dr") {
                return (
                    <div key={boardName} style={{ marginTop: "50px" }}>
                        {genBoardTitle()}
                        {genUserBoard(course_dr, true)}
                    </div>
                );
            } else {
                // return (
                //     <div key={boardName} style={{ marginTop: "50px" }}>
                //         {genBoardTitle()}
                //         {/* <div className="h3">Displaying : {boardName}</div> */}
                //         {/* {genUserBoard(usersBoard)} */}
                //         {genUserBoard()}
                //     </div>
                // );
            }
        }
    } else {
        return <div className="h2">Error Missing Parameters</div>;
    }
}

export function AdminBoardJson() {
    const usersBoard = adminBoard;
    showConsole && console.log("userBoard: ", usersBoard);
    function genUserBoard() {
        return <GenCardsH items={usersBoard} sm={1} md={1} lg={1} />;
    }
    if (usersBoard.length > 0) {
        showConsole && console.log("item:", usersBoard);
        return genUserBoard();
    }
}
